export const range = (start, end, step = 1) => {
  if (step <= 0) throw new Error('range step must be positive');

  const length = Math.floor((end - start) / step) + 1;
  return [...Array(length).keys()].map(x => x * step + start);
};
